__turbopack_context__.v({
  "clearButton": "filter-module-scss-module__lImgZq__clearButton",
  "count": "filter-module-scss-module__lImgZq__count",
  "drawerPanelText": "filter-module-scss-module__lImgZq__drawerPanelText",
  "drawerResetButton": "filter-module-scss-module__lImgZq__drawerResetButton",
  "form": "filter-module-scss-module__lImgZq__form",
  "root": "filter-module-scss-module__lImgZq__root",
});
